export var ChartServices;
(function (ChartServices) {
    ChartServices["ALL"] = "allServices";
    ChartServices["TEMPERATURE"] = "temperature";
    ChartServices["HUMIDITY"] = "humidity";
    ChartServices["PRESSURE"] = "pressure";
    ChartServices["UPTIME"] = "uptime";
    ChartServices["CO2"] = "co2";
})(ChartServices || (ChartServices = {}));
